import LIB from '../utility/Library'
import CONSTANT from '../config/constant'
import Utility from '../utility/Utility'
import ScrollRegister from '../motion/ScrollRegister'

export default class NaviPc extends ScrollRegister {
  constructor() {
    super()
    this.elm = {
      header  : document.getElementById('header'),
      naviLine: document.getElementById('navi-line')
    }
    this.state = {
      isVisible: false
    }
    this.CLASSNAME = {
      VISIBLE: 'is-visible'
    }
    this.naviLine = this.elm.naviLine ? Utility.getElementBottom(this.elm.naviLine) : 0

    this.anchor()
    this.onMouseLeave()
    if (LIB.Visitor().type === 'tablet') {
      this.onClick()
    }
  }

  onClick() {    
    this.elm.header.addEventListener('click', (e) => {
      e.stopPropagation()

      const onMove = () => {
        this.elm.header.classList.remove(CONSTANT.CLASSNAME.ACTIVE)
        window.removeEventListener('scroll', onMove)
        document.body.removeEventListener('click', onMove)
      }

      window.addEventListener('scroll', onMove)
      document.body.addEventListener('click', onMove)
      this.elm.header.classList.add(CONSTANT.CLASSNAME.ACTIVE)
    })
  }

  onMouseLeave() {
    this.elm.header.addEventListener('mouseleave', () => this.handleLeave())
  }

  handleLeave() {
    const handleTransitionEnd = () => {
      this.elm.header.removeEventListener(transitionEnd, handleTransitionEnd)
      this.elm.header.classList.remove(CONSTANT.CLASSNAME.LEAVE)
    }
    this.elm.header.addEventListener(transitionEnd, handleTransitionEnd)
    this.elm.header.classList.add(CONSTANT.CLASSNAME.LEAVE)
  }

  onLoad() {
    if (this.naviLine === 0) {
      this.always = true
      this.elm.header.classList.add(this.CLASSNAME.VISIBLE)
    }
    if (location.hash) {
      window.scrollTo(0, 0)
      document.body.classList.add('is-loaded')
      setTimeout(() => {
        this.smoothScroll(location.hash)
      }, 1000)
    }
  }

  onScrollStart(windowTop, windowBottom) {
    if (this.always) return

    if (windowTop <= this.naviLine) {
      this.elm.header.classList.remove(this.CLASSNAME.VISIBLE)
    } else {
      this.elm.header.classList.add(this.CLASSNAME.VISIBLE)
    }
  }

  anchor() {
    const anchors = document.querySelectorAll('[href^="#"]')

    if (anchors.length > 0) {
      for (let i = 0, length = anchors.length; i < length; i++) {
        anchors[i].addEventListener('click', (e) => {
          this.smoothScroll(anchors[i].hash)
          e.preventDefault()
        })
      }
    }
  }

  smoothScroll(hash) {
    Velocity(document.querySelector(hash), 'scroll', {
      duration: 1400,
      easing  : 'easeInOutQuart'
    })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/common/NaviPc.js